/**
 * Web sitesi URL'lerine göre API versiyonlarını ve base URL'leri belirler
 */

const defaultSubdomain = "slimwell";

const getSubdomain = (pathParts) => {
  return pathParts.slice(0, -2).join(".");
};

const getPathSubdomain = () => {
  // app.sahaskop.com/developer → "developer"
  const firstFolder = window.location.pathname.split("/").filter(Boolean)[0];
  return firstFolder || defaultSubdomain;
};

export const defaultConfig = () => {
  const basename = window.location.hostname;
  console.log(basename, " basename");
  if (basename.includes("sahaskop.com")) {
    // app.sahaskop.com/{folder} → api-{folder}.sahaskop.com
    const subdomain =
      basename === "app.sahaskop.com"
        ? getPathSubdomain()
        : getSubdomain(basename.split("."));
    console.log(subdomain, " subdomain");
    return {
      baseUrl: `https://api-${subdomain}.sahaskop.com`,
      subdomain: subdomain,
      version: "v1",
    };
  } else {
    return {
      baseUrl: `https://api-${defaultSubdomain}.sahaskop.com`,
      subdomain: defaultSubdomain,
      version: "v1",
    };
  }
};

// Web sitesi domainlerine göre API konfigürasyonları
const URL_CONFIGS = {
  "slimwell.softwaremaklerpro.de": {
    baseUrl: "https://slimwell-api.softwaremaklerpro.de",
    version: "v1",
  },
  "slimwell.com": {
    baseUrl: "https://slimwell-api.softwaremaklerpro.de",
    version: "v1",
  },
  "slimwell-v2.softwaremaklerpro.de": {
    baseUrl: "https://slimwell-api.softwaremaklerpro.de",
    version: "v1",
  },
  "kaysan.sahaskop.com": {
    baseUrl: "https://apidemo-kaysan.sahaskop.com",
    version: "v1",
  },
  "birtiklasigorta.sahaskop.com": {
    baseUrl: "https://api-birtiklasigorta.sahaskop.com",
    version: "v1",
  },
  "fygida.sahaskop.com": {
    baseUrl: "https://api-fygida.sahaskop.com",
    version: "v1",
  },
  "boonfresh.sahaskop.com": {
    baseUrl: "https://api-boonfresh.sahaskop.com",
    version: "v1",
  },
  "89.117.49.133:2002": {
    baseUrl: "http://89.117.49.133:2002",
    version: "v2",
  },
  // Diğer domainler için varsayılan değerler
  default: defaultConfig(),
};

// Mevcut domain'e göre konfigürasyon seç
const currentDomain = window.location.hostname;
console.log(currentDomain, " current domain");
const config = URL_CONFIGS[currentDomain] || URL_CONFIGS.default;

// Version'u localStorage'a kaydet
localStorage.setItem("version", config.version);

// Base URL'i dışa aktar
export const BASE_URL = config.baseUrl;
